import "./App.css";
import {
  Routes,
  Route,
  useNavigate,
  HashRouter,
  useLocation,
  Navigate,
} from "react-router-dom";
import CreatorOnboarding from "./pages/CreatorOnboarding/CreatorOnboarding";
import CreatorLanding from "./pages/CreatorLanding/CreatorLanding";
import SignUp from "./pages/signup/SignUp";
import Greate from "./pages/Greate/Greate";
import CommonFileUpload from "./component/CommonFileUploader/CommonFileUpload";
import Mp4FileUpload from "./component/mp4FileUpload/Mp4FileUpload";
import Movie from "./pages/movie/Movie";
import Podcasts from "./pages/Podcasts/Podcasts";
import ShortClips from "./pages/ShortClips/ShortClips";
import LiveStreams from "./pages/LiveStreams/LiveStreams";
import Submissions from "./pages/Submissions/submissions";
import SubmissionDetail from "./pages/Submissions/SubmissionDetail";
import SubmissionSeries from "./pages/Submissions/SubmissionSeries";
import LiveTVChannels from "./pages/LiveTVChannels/LiveTVChannels";
import Series from "./pages/Series/Series";
import MainLayout from "./component/MainLayout/MainLayout";
import Dashboard from "./pages/dashboard/dashboard";
import NotFound from "./pages/NotFound";
import CreatorList from "./pages/CreatorList/CreatorList";
import CreatorMovie from "./pages/CreatorMovie/CreatorMovie";
import CreatorSupport from "./pages/CreatorSupport/CreatorSupport";
import CreatorFaq from "./pages/CreatorFaq/CreatorFaq";
import CreatorHelpCenter from "./pages/CreatorHelpCenter/CreatorHelpCenter";
import SupportTickets from "./pages/SupportTickets/SupportTickets";
import CreatorProfile from "./pages/CreatorProfile/CreatorProfile";
import PillCategories from "./pages/PillCategories/PillCategories";
import AdminLogin from "./pages/login/Login";
import CreatorLogin from "./pages/CreatorLogin/CreatorLogin";
import AcceptInvite from "./pages/acceptInvite/AcceptInvite";
import AddSeries from "./pages/AddSeries/AddSeries";
import Seasons from "./pages/seasons/Seasons";
import Episodes from "./pages/episodes/Episodes";
import AddSeasons from "./pages/AddSeasons/AddSeasons";
import TaxonomyManager from "./component/TaxonomyManager/TaxonomyManager.js";
import { setCssVariables } from "./utils/theme/ColorVariable";
import BuildBadge from "./component/BuildBadge/BuildBadge";
import { useEffect } from "react";
import Users from "./pages/users/Users";
import { SearchProvider } from "./context/SearchContext";
import ProtectedRoute from "./component/ProtectedRoute";
import PublicRoute from "./component/PublicRoute";
import BulkUploadNew from "./pages/bulkUploadNew/BulkUploadNew";
import Subscription from "./pages/subscription/Subscription";
import CreatorRevenue from "./pages/monetization/CreatorRevenue";
import CreatorDetail from "./pages/monetization/CreatorDetail";
import Payouts from "./pages/monetization/Payouts";
import WatchFraudLog from "./pages/monetization/WatchFraudLog";
import MonetizationSettings from "./pages/monetization/MonetizationSettings";
import MonetizationAnalytics from "./pages/monetization/MonetizationAnalytics";
import CreatorMonetization from "./pages/creatorMonetization/CreatorMonetization";
import MovieMonetization from "./pages/creatorMonetization/MovieMonetization";
import AdProviderConfiguration from "./pages/adManagement/AdProviderConfiguration";
import Settings from "./pages/settings/Settings";
import Documents from "./pages/documents/Documents";
import MediaLibraryModal from "./component/mediaLibrary/MediaLibraryModal";
import HomePageBuilder from "./pages/sections-manager/HomePageBuilder";
import ExperienceBuilder from "./pages/sections-manager/ExperienceBuilder";
import { ProgressProvider } from "./context/ProgressContext";
import GlobalUploadTray from "./component/uploadProgressPopup/GlobalUploadTray";
import ImpersonationBanner from "./component/ImpersonationBanner/ImpersonationBanner";
import AnalyticsDashboard from "./pages/analyticsDashboard/AnalyticsDashboard";
import ContentDrilldown from "./pages/analyticsDashboard/sections/ContentDrilldown";
// Cast/Crew refactor — actor management: import for new admin page
import ActorManagement from "./pages/ActorManagement/ActorManagement";
import { Toastify } from "./utils/Toastify/Toastify";
import BulkEpisodes from "./pages/BulkFiles/BulkEpisodes";
import { RbacProvider } from "./rbac/RbacContext";
import { AppConfigProvider } from "./context/AppConfigContext";
import UsersList from "./pages/userManagement/UsersList";
import UserDetails from "./pages/userManagement/UserDetails";
import UserDetailsPage from "./pages/UserDetails/UserDetails";
import RolesList from "./pages/userManagement/RolesList";
import RoleEditor from "./pages/userManagement/RoleEditor";
// Tenant-specific: multi-tenant context provider + hook (tenant name/logo).
import { TenantProvider, useTenant } from "./context/TenantContext";

// Tenant-specific: keep the browser tab title and favicon in sync with the
// active tenant's branding (name + logo) resolved from TenantContext.
function AppTitleUpdater() {
  const { tenant, logoUrl } = useTenant();
  useEffect(() => {
    if (tenant?.name) {
      document.title = `${tenant.name} Admin`;
    }
  }, [tenant?.name]);

  useEffect(() => {
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = logoUrl || "/logo.png";
  }, [logoUrl]);

  return null;
}

function App() {
  useEffect(() => {
    setCssVariables();
  }, []);
  return (
    <>
      {" "}
      <Toastify />{" "}
      <BuildBadge />{" "}
      <TenantProvider>
        <HashRouter>
        {" "}
        <HashRouterGuard /> <StorageWatcher /> <AppTitleUpdater />{" "}
        <AppConfigProvider>
          {" "}
        <SearchProvider>
          {" "}
          <ProgressProvider>
            {" "}
            <RbacProvider>
            {" "}
            <Routes>
              {" "}
              {/* Public Routes */}{" "}
              {/* <Route path="/" element={<AdminLogin />} /> */}{" "}
              {/* "/" is the staff login — except when the page was opened via
                  a creator short link (vh2.tv/creator-signup or
                  /signup-creator, no hash), where it's the creator landing
                  page instead, same as #/creator-studio. */}
              <Route
                path="/"
                element={
                  isCreatorLandingPath() ? (
                    <CreatorLanding />
                  ) : (
                    <PublicRoute>
                      {" "}
                      <AdminLogin />{" "}
                    </PublicRoute>
                  )
                }
              />{" "}
              <Route path="/signup" element={<SignUp />} />{" "}
              {/* Branded creator/partner sign-in door, distinct from the
                  staff AdminLogin at "/". Hits the same /login endpoint and
                  writes the same auth state — it's just a differently
                  branded entry point for Creator-role accounts. */}
              <Route
                path="/creator-login"
                element={
                  <PublicRoute>
                    {" "}
                    <CreatorLogin />{" "}
                  </PublicRoute>
                }
              />{" "}
              {/* Public creator self-signup: opens the onboarding form directly
                  (no invite needed). The register endpoint creates the creator
                  with status "Pending" and no session token — an admin must
                  approve the account before it can log in. An invited creator
                  completing registration here IS approved immediately and does
                  get a token. The protected /creator-onboarding (invite flow)
                  stays unchanged. */}
              <Route path="/creator-signup" element={<CreatorOnboarding />} />{" "}
              {/* Public Help Center (creator FAQ) linked from the creator
                  login page; open to signed-in users too. */}
              <Route path="/creator-help" element={<CreatorHelpCenter />} />{" "}
              {/* Public marketing/onboarding landing page for prospective
                  Creators & Partners; its "Get started" / "Sign in" CTAs
                  route to /creator-signup and / respectively. */}
              <Route path="/creator-studio" element={<CreatorLanding />} />{" "}
              {/* Public staff invite acceptance: the invitee isn't logged in
                  yet; they set their password here to activate the account. */}
              <Route path="/accept-invite" element={<AcceptInvite />} />{" "}
              {/* Protected Routes */}{" "}
              <Route element={<ProtectedRoute />}>
                {" "}
                <Route path="/greate" element={<Greate />} />{" "}
                <Route
                  path="/creator-onboarding"
                  element={<CreatorOnboarding />}
                />{" "}
                {/* Logged-in creator revising a Pending/Rejected/Changes-Requested
                    submission after admin feedback — pre-fills from their current
                    application and resubmits via POST /creators/resubmit instead
                    of registering a new account. */}
                <Route
                  path="/creator-edit-application"
                  element={<CreatorOnboarding editMode />}
                />{" "}
                <Route
                  path="/file-upload/:seriesId?/:seasonId?/:nextEpisodeNumber?"
                  element={<CommonFileUpload />}
                />{" "}
                <Route
                  path="/video/:id?/:seriesId?/:seasonId?/:nextEpisodeNumber?"
                  element={<Mp4FileUpload />}
                />{" "}
                <Route path="/Addseries/:id?" element={<AddSeries />} />{" "}
                {/* Renders full-width without MainLayout's sidebar — the section
                    editor needs the room, same as /file-upload, /Addseries, etc. */}
                <Route
                  path="/home-page-builder"
                  element={<HomePageBuilder />}
                />{" "}
                <Route path="/mainlayout" element={<MainLayout />}>
                  {" "}
                  {/* Redirects for pre-rename bookmarks -- sections-manager
                      and home-page-builder used to live under /mainlayout. */}
                  <Route
                    path="sections-manager"
                    element={<Navigate to="/mainlayout/experience-builder" replace />}
                  />{" "}
                  <Route
                    path="home-page-builder"
                    element={<Navigate to="/home-page-builder" replace />}
                  />{" "}
                  <Route
                    path="media-library/:seriesId?/:seasonId?/:nextEpisodeNumber?"
                    element={<MediaLibraryModal />}
                  />{" "}

                  <Route path="dashboard" element={<Dashboard />} />{" "}
                  <Route path="settings" element={<Settings />} />{" "}
                  <Route path="documents" element={<Documents />} />{" "}
                  <Route path="movie/:metadata_id?" element={<Movie />} />{" "}
                  <Route path="podcasts" element={<Podcasts />} />{" "}
                  <Route path="short-clips" element={<ShortClips />} />{" "}
                  <Route path="live-streams" element={<LiveStreams />} />{" "}
                  <Route path="submissions" element={<Submissions />} />{" "}
                  <Route
                    path="submissions/series/:seriesId"
                    element={<SubmissionSeries />}
                  />{" "}
                  <Route
                    path="submissions/:metaId"
                    element={<SubmissionDetail />}
                  />{" "}
                  <Route path="live-tv-channels" element={<LiveTVChannels />} />{" "}
                  <Route path="series" element={<Series />} />{" "}
                  <Route
                    path="experience-builder"
                    element={<ExperienceBuilder />}
                  ></Route>{" "}
                  <Route
                    path="series/:seriesId/seasons/add/:seasonId?"
                    element={<AddSeasons />}
                  />{" "}
                   <Route
                    path="series/:seriesId/seasons/:seasonId/episodes/bulk"
                    element={<BulkEpisodes />}
                  />{" "}
                  <Route path="seasons/:seriesId" element={<Seasons />} />{" "}

                  <Route
                    path="series/:seriesId/seasons/:seasonId/episodes"
                    element={<Episodes />}
                  />{" "}
                  <Route path="bulk-upload" element={<BulkUploadNew />} />{" "}
                  <Route
                    path="ad-management"
                    element={<AdProviderConfiguration />}
                  />{" "}
                  <Route path="taxonomyManager" element={<TaxonomyManager />} />{" "}
                  <Route path="users" element={<Users />} />{" "}
                  {/* User detail page (userDetail feature) — kept alongside the
                      RBAC user-management pages below so both continue to work. */}
                  <Route path="users/:id" element={<UserDetailsPage />} />{" "}
                  {/* User Management & RBAC (frontend, mock-data backed) */}
                  <Route path="user-management" element={<UsersList />} />{" "}
                  <Route
                    path="user-management/:id"
                    element={<UserDetails />}
                  />{" "}
                  <Route path="roles" element={<RolesList />} />{" "}
                  <Route path="roles/new" element={<RoleEditor />} />{" "}
                  <Route path="roles/:id/edit" element={<RoleEditor />} />{" "}
                  <Route path="creator-list" element={<CreatorList />} />{" "}
                  {/* Cast/Crew refactor — actor management: route for admin actor CRUD page */}
                  <Route
                    path="actor-management"
                    element={<ActorManagement />}
                  />{" "}
                  <Route path="pill-categories" element={<PillCategories />} />{" "}
                  <Route path="subscription" element={<Subscription />} />{" "}
                  <Route
                    path="monetization/creators"
                    element={<CreatorRevenue />}
                  />{" "}
                  <Route
                    path="monetization/creators/:userId"
                    element={<CreatorDetail />}
                  />{" "}
                  <Route
                    path="monetization/payouts"
                    element={<Payouts />}
                  />{" "}
                  <Route
                    path="monetization/watch-fraud-log"
                    element={<WatchFraudLog />}
                  />{" "}
                  <Route
                    path="monetization/settings"
                    element={<MonetizationSettings />}
                  />{" "}
                  <Route
                    path="monetization/analytics"
                    element={<MonetizationAnalytics />}
                  />{" "}
                  <Route
                    path="creator-dashboard"
                    element={<CreatorMonetization />}
                  />{" "}
                  <Route
                    path="monetization/content/:videoMetaId"
                    element={<MovieMonetization />}
                  />{" "}
                  <Route path="creator-movie" element={<CreatorMovie />} />{" "}
                  <Route
                    path="creator-support"
                    element={<CreatorSupport />}
                  />{" "}
                  <Route path="creator-faq" element={<CreatorFaq />} />{" "}
                  <Route
                    path="support-tickets"
                    element={<SupportTickets />}
                  />{" "}
                  <Route
                    path="creator-profile"
                    element={<CreatorProfile />}
                  />{" "}
                  <Route
                    path="analytics-dashboard"
                    element={<AnalyticsDashboard />}
                  />{" "}
                  <Route
                    path="analytics-dashboard/content/:slug"
                    element={<ContentDrilldown />}
                  />{" "}
                </Route>{" "}
              </Route>{" "}
              <Route path="*" element={<NotFound />} />{" "}
            </Routes>{" "}
            </RbacProvider>{" "}
            {/* Upload tray, mounted once for every route. It must live here rather than in
                MainLayout because /file-upload, /video/:id, /Addseries and
                /creator-onboarding render outside that layout — and those are the pages
                uploads are started from. */}
            <GlobalUploadTray />{" "}
            {/* "Viewing as <creator>" while an admin is in a creator's portal. */}
            <ImpersonationBanner />{" "}
          </ProgressProvider>{" "}
        </SearchProvider>{" "}
        </AppConfigProvider>{" "}
      </HashRouter>{" "}
      </TenantProvider>
    </>
  );
}
// Real URL path (outside the hash) of the creator short links. The hash
// router only sees "/" for these, so App checks the path itself.
function isCreatorLandingPath() {
  return /\/(creator-signup|signup-creator)\/?$/.test(window.location.pathname);
}

function HashRouterGuard() {

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
        // If we're at the root without a hash, ensure hash is present
    // HashRouter should handle this, but this is a safety check
    if (window.location.pathname === "/" && !window.location.hash) {
      window.location.hash = "#/";
    }
  }, [location]);

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role === "Creator" && location.pathname === "/mainlayout/dashboard") {
      navigate("/mainlayout/creator-dashboard", { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}

function StorageWatcher() {
  const navigate = useNavigate();

  useEffect(() => {
    const safeParse = (value) => {
      try {
        return JSON.parse(value);
      } catch {
        return null;
      }
    };

    const handleStorageChange = (event) => {
      if (event.key === "userInfo" || event.key === "token") {
        const userInfo = safeParse(localStorage.getItem("userInfo"));
        const token = localStorage.getItem("token");

        // Case 1: User logged out in another tab
        if (!userInfo || !token) {
          navigate("/", { replace: true });

          window.location.reload(); // auto refresh
          return;
        }

        // Case 2: User logged in in another tab
        if (userInfo && token) {
          window.location.reload(); // auto refresh so the app updates
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [navigate]);

  return null;
}

export default App;
